export type GuestClientEvent =
  | 'modal_open'
  | 'modal_close'
  | 'modal_abandon'
  | 'tab_switch'
  | 'client_validation_fail'
  | 'ui_error_shown'
  | 'one_tap_prompt'
  | 'one_tap_skipped'
  | 'one_tap_dismissed'
  | 'one_tap_failed'
  | 'gis_missing'
  | 'google_button_fail'
  | 'guest_page_view'
  | 'guest_prompt_shown'
  | 'wishlist_add'
  | 'wishlist_remove'
  | 'booking_detail_view'
  | 'booking_rate_click'
  | 'booking_status_link'
  | 'wishlist_sync_fail'
  | 'wishlist_merge_on_login'
  | 'newsletter_prompt_shown'
  | 'newsletter_prompt_accepted'
  | 'newsletter_prompt_dismissed'
  | 'newsletter_prompt_hidden_session'

export type GuestClientPayload = Record<string, string | number | boolean>

/**
 * Fire-and-forget client funnel events (D4). Failures are swallowed so the UI
 * never depends on the logger.
 */
export default function useGuestActivityLog () {
  function log (event: GuestClientEvent, payload: GuestClientPayload = {}): void {
    if (!import.meta.client || !useGuestLoginEnabled()) {
      return
    }
    useNuxtApp().$backend.guest.logEventFromClient(event, payload).catch(() => {})
  }

  return { log }
}
